"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableNames = exports.findUiColumnMapping = exports.matchesUiColumnMapping = void 0;
const matchesUiColumnMapping = (columnDef, column) => {
    if (column === undefined) {
        return false;
    }
    return (columnDef.uiTableId === column ||
        columnDef.uiTableName === column ||
        columnDef.aliases?.includes(column) === true);
};
exports.matchesUiColumnMapping = matchesUiColumnMapping;
const findUiColumnMapping = (columnDefs, column) => {
    return columnDefs.find((columnDef) => (0, exports.matchesUiColumnMapping)(columnDef, column));
};
exports.findUiColumnMapping = findUiColumnMapping;
exports.tableNames = [
    "traces",
    "traces_observations",
    "traces_observationsview",
    "observations",
    "traces_scores",
    "traces_metrics",
    "traces_parent_observation_scores",
    "sessions",
    "prompts",
    "users",
    "job_configurations",
    "job_executions",
    "dataset_items",
    "annotation_queue_assignments",
    "dataset_item_events",
];
